<template>
  <DBox
    :id="'cmp-catalog-tracks-sidewindow-track_related_products'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      id="catalog-tracks-sidewindow-track_related_products-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td   v-bind="tdcon('catalog_no')">
            <span
              style="font-weight:400"
              @click.stop="e => onSelectProduct(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['catalog_no']"
            >
              {{ item["catalog_no"] }}
            </span>
          </td>
          <td v-bind="tdcon('release_title')">
            <span class="txtov" :title="item['release_title']">
              {{ item["release_title"] }}
            </span>
          </td>
          <td v-bind="tdcon('format')">
            <span class="txtov" :title="item['format_name']">
              {{ item["format_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('isrc')">
            <TextField2
              :id="'product_isrc'"
              :showLabel="false"
              :value="item['product_isrc']"
              @blur="e => onTextFieldValueChange(e, item)"
              :bb="'none'"
            />
          </td>
          <td v-bind="tdcon('track_grid')">
            <span class="txtov" :title="item['track_grid']">
              {{ item["track_grid"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { EventHooks } from "../../../../plugins/text-field";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedTrackDetails"],
  data: function() {
    return {
      textFieldConfig: {
        height: 27,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      }
    };
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedTrackDetails.products || [];
    },
    headers: function() {
      return [
        createTableHeader("catalog_no", {mw:250, fw: 700 , minw:250}),
        createTableHeader("release_title",{mw:250, minw:250}),
        createTableHeader("format",{mw:150, minw:150}),
        createTableHeader("isrc",{mw:150}),
        createTableHeader("track_grid")
      ];
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onSelectProduct: function(selectedCatalog) {
      this.$emit("selected", selectedCatalog.product_id);
    }
  }
};
</script>
<style lang="scss">
.cmp-catalog-tracks-sidewindow-track_related_products {
  .dt-ntable tbody tr:last-child {
    border-bottom: none;
  }
}
</style>